var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.012 6.515c-.303-.281-.552-.45-.65-.72a.512.512 0 0 1-.036-.268c.014-.21.194-.485 1.392-2.07.5-.661 1.15-1.46 1.15-2.057 0-.387-.158-.482-.731-.482h-2.602c-.228 0-.383.313-.478.577-.098.264-.288.668-.752 1.54-.485.914-1.136 1.715-1.407 1.842a.332.332 0 0 1-.411-.102c-.08-.098-.207-.27-.158-1.895.028-.907.13-1.54-.06-1.926A.667.667 0 0 0 9.1.76C8.83.567 8.067.496 7.413.496c-.654 0-1.157.074-1.406.148-.25.074-.531.243-.665.422-.088.116.151.056.383.162.141.063.327.161.394.327.281.73.341 1.311.186 2.345-.038.253-.08.65-.232.896-.084.137-.277.127-.334.11-.566-.173-1.005-.915-1.448-1.783-.46-.907-.696-1.544-.823-1.804-.126-.26-.32-.4-.647-.4H.487c-.183 0-.348.15-.348.316 0 .386.654 1.511 1.048 2.32a17.534 17.534 0 0 0 2.897 4.226C5.398 9.229 7.19 9.5 7.764 9.5c.574 0 1.02-.021 1.171-.053a.514.514 0 0 0 .2-.088c.25-.193.204-.562.222-.85.018-.296.05-.686.246-.914.183-.215.39-.275.654-.145.246.123.422.33.605.531.355.383.678.816 1.1 1.132.193.144.404.236.63.306.298.092.58.095.889.081.34-.014.598-.01 1.02-.01.421 0 .973.017 1.163-.124a.464.464 0 0 0 .211-.397c0-.418-.429-1.114-1.863-2.454z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca0d92c1c4a7c37fcdaa54957498e111.svg";
export { ForwardRef as ReactComponent };